export const THEME_FONT_CHOICES = [
    { label: 'Inter', stack: '"Inter", sans-serif', group: 'Sans-serif', google: 'Inter:wght@400;500;600;700' },
    { label: 'Archivo', stack: '"Archivo", sans-serif', group: 'Sans-serif', google: 'Archivo:wght@400;600;700' },
    { label: 'DM Sans', stack: '"DM Sans", sans-serif', group: 'Sans-serif', google: 'DM+Sans:wght@400;500;700' },
    { label: 'Poppins', stack: '"Poppins", sans-serif', group: 'Sans-serif', google: 'Poppins:wght@400;500;600;700' },
    { label: 'Montserrat', stack: '"Montserrat", sans-serif', group: 'Sans-serif', google: 'Montserrat:wght@400;500;600;700' },
    { label: 'Raleway', stack: '"Raleway", sans-serif', group: 'Sans-serif', google: 'Raleway:wght@400;500;600;700' },
    { label: 'Nunito', stack: '"Nunito", sans-serif', group: 'Sans-serif', google: 'Nunito:wght@400;600;700' },
    { label: 'Lato', stack: '"Lato", sans-serif', group: 'Sans-serif', google: 'Lato:wght@400;700' },
    { label: 'Outfit', stack: '"Outfit", sans-serif', group: 'Sans-serif', google: 'Outfit:wght@400;500;600;700' },
    { label: 'Space Grotesk', stack: '"Space Grotesk", sans-serif', group: 'Sans-serif', google: 'Space+Grotesk:wght@400;500;700' },
    { label: 'Playfair Display', stack: '"Playfair Display", serif', group: 'Serif', google: 'Playfair+Display:wght@400;600;700' },
    { label: 'DM Serif Display', stack: '"DM Serif Display", serif', group: 'Serif', google: 'DM+Serif+Display' },
    { label: 'Fraunces', stack: '"Fraunces", serif', group: 'Serif', google: 'Fraunces:wght@400;600;700' },
    { label: 'Lora', stack: '"Lora", serif', group: 'Serif', google: 'Lora:wght@400;500;600;700' },
    { label: 'Merriweather', stack: '"Merriweather", serif', group: 'Serif', google: 'Merriweather:wght@400;700' },
    { label: 'Cormorant Garamond', stack: '"Cormorant Garamond", serif', group: 'Serif', google: 'Cormorant+Garamond:wght@400;500;600;700' },
    { label: 'Libre Baskerville', stack: '"Libre Baskerville", serif', group: 'Serif', google: 'Libre+Baskerville:wght@400;700' },
    { label: 'Oswald', stack: '"Oswald", sans-serif', group: 'Display & handwriting', google: 'Oswald:wght@400;500;600;700' },
    { label: 'Bebas Neue', stack: '"Bebas Neue", sans-serif', group: 'Display & handwriting', google: 'Bebas+Neue' },
    { label: 'Anton', stack: '"Anton", sans-serif', group: 'Display & handwriting', google: 'Anton' },
    { label: 'Abril Fatface', stack: '"Abril Fatface", serif', group: 'Display & handwriting', google: 'Abril+Fatface' },
    { label: 'Pacifico', stack: '"Pacifico", cursive', group: 'Display & handwriting', google: 'Pacifico' },
    { label: 'Caveat', stack: '"Caveat", cursive', group: 'Display & handwriting', google: 'Caveat:wght@400;600;700' },
    { label: 'IBM Plex Mono', stack: '"IBM Plex Mono", monospace', group: 'Monospace', google: 'IBM+Plex+Mono:wght@400;600' },
    { label: 'JetBrains Mono', stack: '"JetBrains Mono", monospace', group: 'Monospace', google: 'JetBrains+Mono:wght@400;600' },
    { label: 'System sans', stack: 'system-ui, sans-serif', group: 'System', google: null },
    { label: 'Georgia', stack: '"Georgia", serif', group: 'System', google: null },
    { label: 'System mono', stack: 'ui-monospace, monospace', group: 'System', google: null }
];
const firstFamily = (stack) => (stack.split(',')[0] ?? '').replace(/["']/g, '').trim();
/** The Google Fonts stylesheet URL for the web fonts this theme uses, or null when it only uses system fonts. */
export function themeFontsHref(theme) {
    const specs = [];
    for (const stack of [theme.fonts.heading, theme.fonts.body, theme.fonts.mono]) {
        const name = firstFamily(stack).toLowerCase();
        const choice = THEME_FONT_CHOICES.find((c) => c.label.toLowerCase() === name);
        if (choice?.google && !specs.includes(choice.google))
            specs.push(choice.google);
    }
    return specs.length ? `https://fonts.googleapis.com/css2?${specs.map((s) => `family=${s}`).join('&')}&display=swap` : null;
}
const stackOf = (label) => THEME_FONT_CHOICES.find((c) => c.label === label).stack;
function preset(id, name, p, heading, body, radius) {
    const [background, surface, text, headingColour, accent, accentText, muted, border] = p;
    return {
        id,
        theme: {
            name,
            palette: { background, surface, text, heading: headingColour, accent, accentText, muted, border },
            fonts: { heading: stackOf(heading), body: stackOf(body), mono: stackOf('IBM Plex Mono') },
            radius
        }
    };
}
const SOFT = { sm: '0.375rem', md: '0.75rem', lg: '1.25rem' };
const SQUARE = { sm: '0', md: '0', lg: '0' };
const ROUND = { sm: '0.75rem', md: '1.25rem', lg: '2rem' };
// Colours in order: background, surface, text, heading, accent, accentText, muted, border.
export const THEME_PRESETS = [
    preset('paper-ink', 'Paper & Ink', ['#F3EFE4', '#FFFFFF', '#0F1A2E', '#0F1A2E', '#13295E', '#FFFFFF', '#5B594F', '#E4DCCB'], 'Archivo', 'Archivo', SOFT),
    preset('harbour', 'Harbour', ['#F4F8FA', '#FFFFFF', '#12303F', '#0B2533', '#0B6580', '#FFFFFF', '#4B6674', '#D5E4EB'], 'DM Serif Display', 'Inter', SOFT),
    preset('garden', 'Garden', ['#F6F5EF', '#FFFFFF', '#1F2A22', '#16331F', '#2F6B3F', '#FFFFFF', '#566359', '#DDE3D6'], 'Lora', 'Nunito', SOFT),
    preset('terracotta', 'Terracotta', ['#FBF3EA', '#FFFFFF', '#3B2A22', '#2B1B14', '#A8431A', '#FFFFFF', '#6B564A', '#EAD9C7'], 'Playfair Display', 'Lato', SOFT),
    preset('blush', 'Blush', ['#FDF4F5', '#FFFFFF', '#3A2A30', '#2E1D24', '#B03357', '#FFFFFF', '#6B545B', '#F0DADF'], 'Cormorant Garamond', 'Nunito', ROUND),
    preset('sunshine', 'Sunshine', ['#FFFBEA', '#FFFFFF', '#2B2A22', '#1F1E17', '#A64B05', '#FFFFFF', '#5C5A4B', '#F0E6B8'], 'Poppins', 'DM Sans', ROUND),
    preset('slate-pro', 'Slate Pro', ['#F1F4F8', '#FFFFFF', '#1E2633', '#0F172A', '#1D4ED8', '#FFFFFF', '#506078', '#D8DFEA'], 'Montserrat', 'Inter', SOFT),
    preset('mono', 'Black & White', ['#FFFFFF', '#F5F5F5', '#111111', '#000000', '#000000', '#FFFFFF', '#555555', '#DDDDDD'], 'Space Grotesk', 'Inter', SQUARE),
    preset('midnight', 'Midnight', ['#0F1220', '#181C30', '#E6E8F2', '#FFFFFF', '#9AA2FF', '#0F1220', '#A2A8C3', '#2A3050'], 'Space Grotesk', 'Inter', SOFT),
    preset('noir-gold', 'Noir & Gold', ['#121212', '#1C1B1A', '#E9E4D8', '#F7F2E4', '#D4AF37', '#121212', '#A7A090', '#34312B'], 'Cormorant Garamond', 'Lato', SQUARE)
];
export const THEME_RADIUS_PRESETS = [
    { id: 'sharp', label: 'Sharp', radius: SQUARE },
    { id: 'soft', label: 'Soft', radius: SOFT },
    { id: 'round', label: 'Round', radius: ROUND },
    { id: 'pill', label: 'Pill', radius: { sm: '999px', md: '1.5rem', lg: '2.25rem' } }
];
export const THEME_SPACING_PRESETS = [
    { id: 'compact', label: 'Compact', spacing: { section: '3rem', container: '64rem' } },
    { id: 'comfortable', label: 'Comfortable', spacing: { section: '4.5rem', container: '72rem' } },
    { id: 'airy', label: 'Airy', spacing: { section: '6.5rem', container: '76rem' } }
];
function channel(hex, i) {
    const v = parseInt(hex.slice(1 + i * 2, 3 + i * 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
}
/** WCAG contrast ratio between two #rrggbb colours (null when either is not a 6-digit hex colour). */
export function contrastRatio(a, b) {
    const ok = (c) => /^#[0-9a-fA-F]{6}$/.test(c);
    if (!ok(a) || !ok(b))
        return null;
    const lum = (c) => 0.2126 * channel(c, 0) + 0.7152 * channel(c, 1) + 0.0722 * channel(c, 2);
    const [hi, lo] = [lum(a), lum(b)].sort((x, y) => y - x);
    return (hi + 0.05) / (lo + 0.05);
}
//# sourceMappingURL=theme-presets.js.map